import { customInstance } from "../../custom-instance";
export const get = () => {
    const expenditureResolutionControllerGetList = (params) => {
        return customInstance({
            url: `/expenditure-resolution`,
            method: "GET",
            params,
        });
    };
    const expenditureResolutionControllerPostCreate = (createExpenditureResolutionDto) => {
        return customInstance({
            url: `/expenditure-resolution`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: createExpenditureResolutionDto,
        });
    };
    const expenditureResolutionControllerGetOne = (id) => {
        return customInstance({
            url: `/expenditure-resolution/${id}`,
            method: "GET",
        });
    };
    const expenditureResolutionControllerPatchUpdate = (id, updateExpenditureResolutionDto) => {
        return customInstance({
            url: `/expenditure-resolution/${id}`,
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            data: updateExpenditureResolutionDto,
        });
    };
    const expenditureResolutionControllerDeleteOne = (id) => {
        return customInstance({
            url: `/expenditure-resolution/${id}`,
            method: "DELETE",
        });
    };
    const expenditureResolutionControllerPatchSubmit = (id) => {
        return customInstance({
            url: `/expenditure-resolution/${id}/submit`,
            method: "PATCH",
        });
    };
    const expenditureResolutionControllerPatchCancelSubmission = (id) => {
        return customInstance({
            url: `/expenditure-resolution/${id}/cancel`,
            method: "PATCH",
        });
    };
    const expenditureResolutionControllerPatchPayment = (id, markPaymentCompleteDto) => {
        return customInstance({
            url: `/expenditure-resolution/${id}/payment`,
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            data: markPaymentCompleteDto,
        });
    };
    return {
        expenditureResolutionControllerGetList,
        expenditureResolutionControllerPostCreate,
        expenditureResolutionControllerGetOne,
        expenditureResolutionControllerPatchUpdate,
        expenditureResolutionControllerDeleteOne,
        expenditureResolutionControllerPatchSubmit,
        expenditureResolutionControllerPatchCancelSubmission,
        expenditureResolutionControllerPatchPayment,
    };
};
